import type { ChartV2Horizon, ChartV2Interval } from './types/chart-v2.types';

export const DEFAULT_PANE_ID_PREFIX = 'pane-';
export const DEFAULT_PANE_ID = `${DEFAULT_PANE_ID_PREFIX}0`;

const DAY_MS = 24 * 60 * 60 * 1000;

export const CHARTV2_HORIZON_SPAN_MS: Record<ChartV2Horizon, number | null> = {
  '1D': 1 * DAY_MS,
  '1W': 7 * DAY_MS,
  '2W': 14 * DAY_MS,
  '1M': 30 * DAY_MS,
  '2M': 61 * DAY_MS,
  '3M': 91 * DAY_MS,
  '6M': 182 * DAY_MS,
  '1Y': 365 * DAY_MS,
  '3Y': 3 * 365 * DAY_MS,
  '5Y': 5 * 365 * DAY_MS,
  '10Y': 10 * 365 * DAY_MS,
  MAX: null,
};

export const DEFAULT_HORIZONS = Object.keys(
  CHARTV2_HORIZON_SPAN_MS
) as ChartV2Horizon[];

export const DEFAULT_INTERVALS: ChartV2Interval[] = [
  '1m',
  '5m',
  '15m',
  '30m',
  '1h',
  '1D',
  '1W',
  '1M',
];
